import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-nav-down",
  "use": "icon-nav-down-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-nav-down\"><path d=\"m10.6 8.9-2.1 2.2V3h-1v8.1L5.4 8.9l-.8.7L8 13l3.4-3.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol